module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-henkel-1-ae50776def0f3c57ecd67797d62ad1a1.jpg";